module.exports = __webpack_public_path__ + "img/night-vision-equipment.6137549f.png";